module.exports = __webpack_public_path__ + "img/loyalty_selft.8126cff9.jpg";